//This file is generated by a script. Do not edit directly.
export default {"sm":"640px","md":"768px","lg":"1184px","xl":"1280px"};